module.exports = __webpack_public_path__ + "img/control_your_credit.a32c71ce.jpg";